var webooker_schedule_models = webooker_schedule_models || {};

(function (ns) {

    ns.UserScheduleDetail = function (userScheduleDetailDto) {

        this.dto = userScheduleDetailDto;

        this.attendanceChangesAllowed = userScheduleDetailDto.attendanceChangesAllowed;
        this.attendanceChangesInTime = userScheduleDetailDto.attendanceChangesInTime;
        this.compensationGroup = userScheduleDetailDto.compensationGroup;
        this.freeSlots = userScheduleDetailDto.freeSlots;      
        this.subjectCategoryID = userScheduleDetailDto.subjectCategoryID;

        this.waitQueue = [];
        for (var w = 0; w < userScheduleDetailDto.waitQueue.length; w++) {
            var userScheduleDetailWaitQueueItemDto = userScheduleDetailDto.waitQueue[w];
            this.waitQueue.push(new ns.UserScheduleDetailWaitQueueItem(userScheduleDetailWaitQueueItemDto, this));
        }

        this.showCompensationGroupHelp = !!this.compensationGroup && this.attendanceChangesAllowed && this.subjectCategoryID === 1;
        this.oneOffDisabledHelp = false;
        this.showPriceColum = false;
        this.showExcuseHelp = false;
        this.showUnregisterHelp = false;
        this.showRegisterHelp = false;
        this.showAmendHelp = false;
        this.showOneOffRegHelp = false;

        this.showActionRegHelp = false;
        this.showActionUnRegHelp = false;
        this.showAttendanceTypeColumn = this.subjectCategoryID === 1; // RegularCourses
        this.showAvailableAmendsColumn = this.subjectCategoryID === 1; // RegularCourses

        this.studentsAttendance = [];
        for (var s = 0; s < userScheduleDetailDto.studentsAttendance.length; s++) {
            var userScheduleDetailAttendanceDto = userScheduleDetailDto.studentsAttendance[s];
            var userScheduleDetailAttendance = new ns.UserScheduleDetailAttendance(userScheduleDetailAttendanceDto, this);
            this.studentsAttendance.push(userScheduleDetailAttendance);

            this.oneOffDisabledHelp = this.oneOffDisabledHelp || userScheduleDetailAttendance.oneOffDisabled;
            this.showPriceColum = this.showPriceColum || 
                                   (userScheduleDetailAttendance.courseAttendanceTypeID === 1 &&
                                   !!userScheduleDetailAttendance.causalPrice &&
                                   (this.attendanceChangesAllowed || userScheduleDetailAttendance.present));

            var effectivePresent = userScheduleDetailAttendance.present;
            if (!effectivePresent) {
                var waitQueuePresent = _.find(this.waitQueue, function (w) { return w.studentID === userScheduleDetailAttendance.studentID });
                effectivePresent = !!waitQueuePresent;
            }

            if (effectivePresent) {
                this.showExcuseHelp = this.attendanceChangesAllowed && this.subjectCategoryID === 1;
                this.showUnregisterHelp = this.attendanceChangesAllowed && this.subjectCategoryID === 1;
                this.showActionUnRegHelp = this.attendanceChangesAllowed && this.subjectCategoryID === 2;
            } else {
                this.showRegisterHelp = this.attendanceChangesAllowed && this.subjectCategoryID === 1;
                this.showActionRegHelp = this.attendanceChangesAllowed && this.subjectCategoryID === 2;

                if (userScheduleDetailAttendance.effectiveCourseAttendanceTypeID === 2) {
                    this.showAmendHelp = this.attendanceChangesAllowed && this.subjectCategoryID === 1;
                }

                if (userScheduleDetailAttendance.effectiveCourseAttendanceTypeID === 1) {
                    this.showOneOffRegHelp = (this.showOneOffRegHelp ||
                        (this.attendanceChangesAllowed && !userScheduleDetailAttendance.presentReadOnly)) && this.subjectCategoryID === 1;
                }
            }

        }

        this.showNoStudentsHelp = this.studentsAttendance.length === 0;
        this.oneOffDisabledHelp = this.oneOffDisabledHelp && this.attendanceChangesAllowed && this.subjectCategoryID === 1;
    }

    ns.UserScheduleDetail.prototype.getVirtualWaitQueueIndex = function (attendance, newPresent, oldPresent) {
        //var queueIndex = -1;
        var virtualIndex = -this.freeSlots;
        var a, att;


        for (var q = 0; q < this.waitQueue.length; q++) {
            var queueItem = this.waitQueue[q];

            virtualIndex = virtualIndex + 1;

            att = _.find(this.studentsAttendance, function (a) { return a.studentID === queueItem.studentID });
            if (att) {
                if (att === attendance) {
                    if (!newPresent) {
                        virtualIndex = virtualIndex - 1;
                    }
                } else {
                    if (!att.present) {
                        virtualIndex = virtualIndex - 1;
                    }
                }
            }

            if (att === attendance) {
                if (newPresent) {
                    return virtualIndex;
                } else {
                    return null;
                }
            }
        }

        for (a = 0; a < this.studentsAttendance.length; a++) {
            att = this.studentsAttendance[a];

            if (att === attendance) {
                if (newPresent && !oldPresent) {
                    // new present
                    virtualIndex = virtualIndex + 1;
                } else {
                    if (!newPresent && oldPresent) {
                        if (!_.find(this.waitQueue, function (w) { return w.studentID === att.studentID })) {
                            virtualIndex = virtualIndex - 1;
                        }
                    }
                }

            }
            else {
                if (att.present && !att.dto.present) {
                    // new present
                    virtualIndex = virtualIndex + 1;
                } else {
                    if (!att.present && att.dto.present) {
                        if (!_.find(this.waitQueue, function (w) { return w.studentID === att.studentID })) {
                            virtualIndex = virtualIndex - 1;
                        }
                    }
                }
            }

            if (att === attendance) {
                if (virtualIndex > 0 && newPresent && !oldPresent) {
                    return virtualIndex;
                } else {
                    return null;
                }
            }

        }

        return null;
    }

    ns.UserScheduleDetail.prototype.getPresentStudentsIDs = function () {

        var studentIDs = [];
        for (var a = 0; a < this.studentsAttendance.length; a++) {
            var att = this.studentsAttendance[a];
            if (att.present) {
                studentIDs.push(att.studentID);
            }
        }

        return studentIDs;
    }

    Object.defineProperty(ns.UserScheduleDetail.prototype, 'showQueueColumn', {
        enumerable: true, configurable: true,
        get: function () {

            for (var a = 0; a < this.studentsAttendance.length; a++) {
                var att = this.studentsAttendance[a];
                if (att.waitQueueIndex !== null) {
                    return true;
                }
            }

            return false;
        }
    });

    Object.defineProperty(ns.UserScheduleDetail.prototype, 'showCompensationWaitQueueHelp', {
        enumerable: true, configurable: true,
        get: function () {
            return this.showQueueColumn && this.subjectCategoryID === 1; // RegularCourses
        }
    });

    Object.defineProperty(ns.UserScheduleDetail.prototype, 'showCompensationWaitQueueForActionHelp', {
        enumerable: true, configurable: true,
        get: function () {
            return this.showQueueColumn && this.subjectCategoryID === 2; // OneOffActions
        }
    });

    Object.defineProperty(ns.UserScheduleDetail.prototype, 'isDirty', {
        enumerable: true, configurable: true,
        get: function () {

            for (var a = 0; a < this.studentsAttendance.length; a++) {
                var att = this.studentsAttendance[a];
                if (att.present !== att.dto.present) {
                    return true;
                }
            }

            return false;
        }
    });


})(webooker_schedule_models);